import { createFileRoute } from '@tanstack/react-router'
import { FeedbackDetailScreen } from '@/features/feedback/feedback-detail'

/**
 * Route shell for one feedback report's detail (design spec §5.2).
 *
 * Per the route-shell rule, this file is a route definition and a render. The
 * screen lives in `src/features/feedback/`.
 */
export const Route = createFileRoute('/_authenticated/feedback/$reportId')({
  component: FeedbackDetailRoute,
})

function FeedbackDetailRoute() {
  const { reportId } = Route.useParams()

  return <FeedbackDetailScreen reportId={reportId} />
}
